import { withProps, StyledElement } from '@udecode/plate';

import { CSSProp } from 'styled-components';
import styles from 'src/shared/styles/richText';

const H3 = withProps(StyledElement, {
  as: 'h3',
  styles: {
    root: styles.h3 as CSSProp,
  },
});

export default H3;
